import { BatchResult } from './batch-result';
import { CoordinatorService } from './coordinator.service';
import { Filter } from './filter';
import { SEARCH_HELP, SEARCH_ITEM_HELP_DATA } from './search-archive$';
import { XItem } from './x-item';

const filterTagLs = [
    'year',
    'source',
    'author',
    'author-first',
    'author-last',
    'has',
    'doctype',
    'language',
    'keyword',
];
export class Filter$ {
    private _filterCollectionMap = new Map<string, Filter>();
    private _filterPreviewMap = new Map<string, Filter>();
    private _idSet?: Set<string>;
    widgetSize = 5;
    dialogSize = 100;

    constructor(private coords: CoordinatorService) {
        this.clear();
    }

    stageChange() {
        this.run();
    }

    refreshKeywords() {
        const tag = 'keyword';
        const colF = new Filter(this.coords, tag);
        const prevF = new Filter(this.coords, tag, true);
        this._filterCollectionMap.set(tag, colF);
        this._filterPreviewMap.set(tag, prevF);
        this.run();
    }

    get isActive() {
        return this._idSet !== undefined;
    }
    process(ls: XItem[]) {
        if (!this.isActive) return ls;
        return ls.filter((xitm) => this._idSet!.has(xitm.id));
    }

    run() {
        let s: Set<string>;
        this.filterLs().forEach((filter) => {
            if (filter.isActive) {
                if (s === undefined) {
                    s = new Set<string>(filter.idSet);
                } else {
                    for (const id of s) {
                        if (!filter.idSet!.has(id)) s.delete(id);
                    }
                }
            }
        });
        this._idSet = s!;
        this.coords.resultList$.markForCheck();
    }

    clear() {
        this._filterCollectionMap.clear();
        this._filterPreviewMap.clear();
        filterTagLs.forEach((tag) => {
            this._filterCollectionMap.set(tag, new Filter(this.coords, tag));
            this._filterPreviewMap.set(tag, new Filter(this.coords, tag, true));
        });
    }

    batchFilter(br: BatchResult) {
        const tag = `batch-${br.id}`;
        let bf = this._filterCollectionMap.get(tag);
        if (!bf) {
            const fLs = Array.from(this._filterCollectionMap.entries());
            bf = new Filter(this.coords, tag);
            fLs.unshift([bf.tag, bf]);
            this._filterCollectionMap = new Map(fLs);
        }

        return bf;
    }

    clearButtonAction() {
        this.filterLs().forEach((filter) => filter.clear());
        this.run();
    }

    private get _mp() {
        return this.coords.stage$.isPreview ? this._filterPreviewMap : this._filterCollectionMap;
    }

    filterLs(isAll = false) {
        const ls = Array.from(this._mp.values());
        return isAll ? ls : ls.filter((x) => !x.isHidden);
    }

    get(tag: string) {
        return this._mp.get(tag);
    }

    save(ls: string[]) {
        if (!this.isActive) return;
        ls.push(`const filterBoard = searchInterface.widget('filter-board')`);
        this.filterLs().forEach((filter) => filter.save(ls));
    }

    saveRun(ls: string[]) {
        if (!this.isActive) return;
        this.filterLs().forEach((filter) => filter.saveRun(ls));
    }

    saveHelp(resp: SEARCH_HELP) {
        resp.filterLs = this.filterLs()
            .map((filter) => filter.saveHelp())
            .filter((x) => x) as SEARCH_ITEM_HELP_DATA[];
    }
}
